import React, { useState } from "react";
import { Button, message } from "antd";
import { updateKitchenOrder } from "../../../../network/network";
import { useTranslation } from "react-i18next";
import {
  handleApiError,
  showAppError,
} from "../../../../utils/errorHandler";

const UpdateKitchenOrders = ({
  order_id,
  status,
  title = "Update",
  onSuccess = () => {},
  onError = () => {},
  onUnauthorized = () => {},
  type = "primary",
  block = true,
  size = "large",
  className = "",
  disabled = false,
}) => {
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();

  const handleUpdate = async () => {
    if (!order_id || !status) {
      showAppError("Missing order_id or status");
      return;
    }

    try {
      setLoading(true);

      const response = await updateKitchenOrder({
        order_id,
        status,
      });

      if (response?.data?.success === false) {
        handleApiError(response, t);
        onError(response);
        return;
      }

      message.success("Order updated successfully");
      onSuccess();
    } catch (err) {
      if (err?.response?.status === 401) {
        onUnauthorized(err);
        return;
      }

      handleApiError(err, t);
      onError(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Button
      type={type}
      block={block}
      size={size}
      className={className}
      loading={loading}
      disabled={disabled || loading}
      onClick={handleUpdate}
    >
      {title}
    </Button>
  );
};

export default UpdateKitchenOrders;
